import fm from 'format-message';
import PropTypes from 'prop-types';
import { styled } from '@activebrands/core-web/libs/styletron';
import EditIcon from 'components/icons/EditIcon';

const Button = styled('button', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const EditButton = ({ $style = {}, onClick }) => (
    <Button $style={$style} type="button" onClick={onClick}>
        {fm('Edit')}
        <EditIcon $style={{ marginLeft: '8px' }} />
    </Button>
);

EditButton.propTypes = {
    $style: PropTypes.object,
    onClick: PropTypes.func,
};

export default EditButton;
